"use strict";

import { jwtDecode } from "jwt-decode";
import cookieToken from "./cookie-token";

let clockOffsetMs = 0;
let token = null;
let useCookies = true;

const MAX_COOKIE_SIZE = 4000;

module.exports = {
  initialize: function (cookieManager) {
    cookieToken.initialize(cookieManager);
  },
  set: function (value) {
    clockOffsetMs = jwtDecode(value).iat * 1000 - Date.now();
    if (useCookies) {
      try {
        cookieToken.set(value);
        // Verify cookie was actually stored by reading it back
        const storedValue = cookieToken.load();
        if (storedValue !== value) {
          throw new Error("Cookie storage verification failed");
        }
      } catch (error) {
        const isCookieTooLarge = value.length > MAX_COOKIE_SIZE;
        if (!isCookieTooLarge) {
          console.error(
            "Failed to store token in cookie, falling back to in-memory storage:",
            error.message,
          );
        }
        useCookies = false;
        token = value;
      }
    } else {
      token = value;
    }
  },
  load: function () {
    if (useCookies) {
      return cookieToken.load();
    }
    return token;
  },
  remove: function () {
    // for existing cookies or when cookies are enabled, remove them
    if (useCookies || cookieToken.load()) {
      cookieToken.remove();
    } else {
      token = null;
    }
  },
  isExpired: function () {
    let currentToken = useCookies ? cookieToken.load() : token;
    if (!currentToken || typeof currentToken !== "string") {
      return true;
    }
    let decoded = jwtDecode(currentToken);
    const refreshInAdvanceMs = 5000;
    if (Date.now() + clockOffsetMs + refreshInAdvanceMs >= decoded.exp * 1000) {
      return true;
    }
    return false;
  },
  useCookies: function () {
    useCookies = true;
  },
};
